module.exports = __webpack_public_path__ + "media/Video 96.56690700.mp4";